export function clamp(v: number, lo: number = 0, hi: number = 1): number {
  return Math.max(lo, Math.min(hi, v));
}

export function lerp(a: number, b: number, t: number): number {
  return a + (b - a) * t;
}

export function phase(t: number, range: [number, number]): number {
  const [a, b] = range;
  return clamp((t - a) / (b - a), 0, 1);
}

export function smooth(t: number): number {
  const c = clamp(t);
  return c * c * (3 - 2 * c);
}

// Deterministic LCG — ported from Atmosphere.jsx:11-14.
export function lcg(seed: number, count: number): number[] {
  let s = seed;
  const out: number[] = [];
  for (let i = 0; i < count; i++) {
    s = (s * 9301 + 49297) % 233280;
    out.push(s / 233280);
  }
  return out;
}
